// extracted by mini-css-extract-plugin
export default {"maincontainer":"Settings_maincontainer__92A3i"};